import React from 'react';
import GeneralSettingsContainer from './GeneralSettingsContainer';

const SettingsGeneralTab = () => <GeneralSettingsContainer />;

export default SettingsGeneralTab;
